import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import storage from "redux-persist/lib/storage"; // Uses localStorage
import { persistReducer } from "redux-persist";
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";

import gameSettingsReducer from "./slices/gameSettingsSlice";
import betHistoryReducer from "./slices/betHistorySlice";
import placeBetReducer from "./slices/placeBetSlice";
import freeSpinReducer from "./slices/freeSpinSlice";
import betCompleteReducer from "./slices/betCompleteSlice"

// 🔹 Create Persist Config
const persistConfig = {
  key: "root", // Storage key
  storage,     // Use localStorage
};
const rootReducer = combineReducers({
  gameSettings: gameSettingsReducer,
  betHistory: betHistoryReducer,
  placeBet: placeBetReducer,
  freeSpin: freeSpinReducer,
  completeBet: betCompleteReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ["payload.headers", FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER], // Disable checks for specific paths
      },
    }),
});

export default store;
